import { FormLabel as ChakraFormLabel, FormLabelProps as ChakraFormLabelProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

export type FormLabelProps = ChakraFormLabelProps;

const propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
};

const defaultProps = {
  size: 'md'
};
const FormLabel = (props: FormLabelProps): React.ReactElement => {
  return <ChakraFormLabel {...props} />;
};

FormLabel.propTypes = propTypes;
FormLabel.defaultProps = defaultProps;

export default FormLabel;
